import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function SafetySection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1];
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';

  const cards = [
    { icon: 'ri-link', text: 'safety.card1' },
    { icon: 'ri-lock-password-line', text: 'safety.card2' },
    { icon: 'ri-price-tag-3-line', text: 'safety.card3' },
    { icon: 'ri-image-line', text: 'safety.card4' },
    { icon: 'ri-truck-line', text: 'safety.card5' },
    { icon: 'ri-government-line', text: 'safety.card6' },
    { icon: 'ri-spam-2-line', text: 'safety.card7' },
    { icon: 'ri-shield-user-line', text: 'safety.card8' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('safety.h2')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6 mb-10">
          {cards.map((card, i) => (
            <div
              key={i}
              className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                <i className={`${card.icon} text-lg`} />
              </div>
              <p className="text-sm font-medium text-foreground-700">{t(card.text)}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href={`/${currentLang}/articles/cssbuy-spreadsheet-guide`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            {t('safety.cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}